// React
import * as React from 'react'
import styled from 'styled-components'

const StyledContainer = styled.div`
  .PageViewContent {
    margin-bottom: 0px;
  }
`
class Content extends React.Component {
  /**
   * Render the main content
   * @returns {any}
   */
  render() {
    return (
      <StyledContainer>
        <div className="PageViewContent">{this.props.children}</div>
      </StyledContainer>
    )
  }
}

export default Content



// WEBPACK FOOTER //
// ./src/presentations/views/PageView/Content.tsx